import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./state/layout"; // the layout mode on <html> before the first paint
import "./state/freshness"; // reload a resumed tab when a new version has been deployed
import "./kit/kit.css";
import "./kit/city.css";
import "./kit/responsive.css";
// Screen finishes build on the kit; load them after the shared surfaces and geometry.
import { App } from "./app/App";
import { GamePromptError } from "./api/http";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, err) => !(err instanceof GamePromptError && (err.code === "signed_out" || err.code === "game")) && count < 2,
      refetchOnWindowFocus: true,
      staleTime: 10_000,
    },
    mutations: { retry: 0 },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
